/* eslint-disable import/no-cycle */
import {
  Col, Row, Space, Spin, Typography
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DropdownElement } from 'common/components/DropdownType';
import Input from 'common/components/Input';
import { packageDurations, packageType } from 'extends/AddOnPackageDetail';

interface PackageGeneralInfoProps {
  method: UseFormReturn<any>;
  isLoading?: boolean;
}

const PackageGeneralInfo = ({ isLoading, method }: PackageGeneralInfoProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Spin />;
  }

  return (
    <Space direction="vertical" className="u-mt-16 p-packageDetail_generalInfo_wrapper">
      <Row gutter={16}>
        <Col span={12}>
          <Typography.Text strong>{t('package.nameServicePackage')}</Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <Controller
            control={method.control}
            name="name"
            defaultValue=""
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Input
                className="u-mt-8"
                name="name"
                placeholder="Enter package name"
                value={value}
                onChange={onChange}
                error={error?.message}
                size="large"
              />
            )}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Typography.Text strong>{t('package.duration')}</Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <Controller
            control={method.control}
            name="duration"
            defaultValue=""
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <DropdownElement
                locale="vi"
                options={packageDurations(t)}
                placeholder="---"
                isGetOption
                value={value}
                isShowSearch
                onChange={onChange}
                error={error?.message}
              />
            )}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Typography.Text strong>{t('add_on_package.type')}</Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <Controller
            control={method.control}
            name="type"
            defaultValue=""
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <DropdownElement
                locale="vi"
                options={packageType()}
                placeholder="---"
                isGetOption
                value={value}
                isShowSearch
                onChange={onChange}
                error={error?.message}
              />
            )}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Typography.Text strong>{t('add_on_package.description')}</Typography.Text>
          <Controller
            control={method.control}
            name="descriptions"
            defaultValue=""
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <div>
                <TextArea
                  className="u-mt-8"
                  name="descriptions"
                  placeholder="Enter description"
                  value={value}
                  onChange={onChange}
                  size="large"
                />
                {error && (
                  <span
                    className="a-input_errorMessage"
                  >
                    {error.message}
                  </span>
                )}

              </div>

            )}
          />
        </Col>
      </Row>
    </Space>
  );
};

export default PackageGeneralInfo;
